import React from "react";
import { checkTranslation } from "../../utils/useful";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class LicenseInput extends React.Component {

    state = {
        checked: true
    }

    componentWillMount() {

    }

    checkSettings(param) {
        if (this.props.settings) {
            return this.props.settings[param]
        } else {
            return false
        }
    }

    changeValue = (target) => {

        let newValue = this.props.data != null ? this.props.data : false
        newValue = !newValue
        this.props.changeValue(this.props.header.key, newValue, this.props.extra)

    }

    render() {
        let info = this.props.header?.information
        return (
            <div className='flexc'>
                <label className={"switch small " + (info?.size ?? '')}>
                    <input type="checkbox"
                        name={this.props.header.key}
                        id={this.props.header.key}
                        checked={this.props.data != null ? this.props.data : false}
                        disabled={info?.disabled}
                        onChange={e => this.changeValue(e.target)} />
                    <span className={" round " + (info.className ?? " slider ")}></span>
                </label>


                <label className={' label-text switch-label  mld-3 mrd-1  mb-0 ' + (info?.required ? 'required' : '')} >{checkTranslation(info?.label)}</label>


                <div className="mld-2 br-20 px-1 py-1 text-smaller flexc" style={{ color: '#777', background: '#eee' }}>

                    <img src="/assets/icons/applets/general/diamond-award.png" height={20} alt="" />
                    {info.type != 'group' && (
                        <span className="mrd-3 mld-2">5 available / 10 Total</span>
                    )}
                </div>

            </div>
        );
    }
}

export default LicenseInput;
